
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 20 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.633 11.692c.067-.55.117-1.1.117-1.667 0-.566-.05-1.116-.117-1.666h2.817a6.87 6.87 0 01.217 1.666 6.87 6.87 0 01-.217 1.667m-4.292 4.633c.5-.925.884-1.925 1.15-2.966h2.459a6.691 6.691 0 01-3.609 2.966zm-.208-4.633h-3.9c-.083-.55-.133-1.1-.133-1.667 0-.566.05-1.125.133-1.666h3.9c.075.541.133 1.1.133 1.666 0 .567-.058 1.117-.133 1.667zM10 16.659c-.692-1-1.25-2.109-1.592-3.3h3.184c-.342 1.191-.9 2.3-1.592 3.3zM6.667 6.692H4.233a6.603 6.603 0 013.6-2.967c-.5.925-.875 1.925-1.166 2.967zm-2.434 6.667h2.434c.291 1.041.666 2.041 1.166 2.966a6.673 6.673 0 01-3.6-2.966zm-.683-1.667a6.868 6.868 0 01-.217-1.667c0-.575.084-1.133.217-1.666h2.817c-.067.55-.117 1.1-.117 1.666 0 .567.05 1.117.117 1.667M10 3.384c.692 1 1.25 2.116 1.592 3.308H8.408A11.35 11.35 0 0110 3.384zm5.767 3.308h-2.459a13.04 13.04 0 00-1.15-2.967 6.656 6.656 0 013.609 2.967zm-5.767-5c-4.608 0-8.333 3.75-8.333 8.333A8.333 8.333 0 1010 1.692z"}})])
          )
        }
      }
    